import { controlMap } from "./control.js";
import { extendMember, extendBinding, extendEvent } from "./info_extend.js";
function getComponentInfo(component, documentation) {
  extendInfo(documentation, component);
  return documentation;
}
function extendInfo(info, component) {
  if (!info) {
    return;
  }
  renameModelProp(info);
  const attributes = getAttributes(info);
  if (info.slots) {
    info.slots = processMembers(info.slots);
  }
  if (info.props) {
    const defaultCache = getComponentDefaults(component);
    info.props = processMembers(info.props, (binding) => extendBinding(binding, defaultCache));
  }
  if (attributes) {
    info.attributes = processMembers(attributes);
  }
  if (info.events) {
    info.events = processMembers(info.events, extendEvent);
  }
}
function renameModelProp(info) {
  var _a, _b;
  const model = (_a = info.props) == null ? void 0 : _a.find((componentProp) => {
    const tags = componentProp.tags;
    return tags ? "model" in tags : false;
  });
  if (model) {
    model.name = (_b = model.tags.model[0]) == null ? void 0 : _b.description;
  }
}
function getAttributes(info) {
  const properties = info.tags.property;
  if (!properties) {
    return null;
  }
  return properties.filter((property) => {
    return property.description === "attribute";
  }).map((property) => {
    const type = property.type.name.toLowerCase();
    const defaultValue = controlMap[type].default();
    return {
      name: property.name,
      type: {
        name: type
      },
      initialValue: defaultValue,
      defaultValue
    };
  });
}
function processMembers(members, ...processors) {
  return members == null ? void 0 : members.map((member) => {
    extendMember(member);
    processors.forEach((processor) => {
      processor(member);
    });
    return member;
  });
}
function getComponentDefaults(component) {
  var _a, _b, _c;
  const componentSearchObjects = [
    component.props,
    ...((_a = component.mixins) == null ? void 0 : _a.map((mixin) => mixin.props)) ?? [],
    ...((_c = (_b = component.extends) == null ? void 0 : _b.mixins) == null ? void 0 : _c.map((mixin) => mixin.props)) ?? []
  ].filter((obj) => obj);
  return {
    ...Object.fromEntries(componentSearchObjects.filter((path) => path).map((path) => {
      return Object.entries(path).map(([entryKey, entryValue]) => {
        const entryDefault = entryValue.default;
        return [
          entryKey,
          entryValue.type !== Function && typeof entryDefault === "function" ? entryDefault() : entryDefault
        ];
      });
    }).flat())
  };
}
export {
  getComponentInfo
};
//# sourceMappingURL=info.js.map
